import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid } from "@material-ui/core";
import WorkingsDays from './WorkingsDays';
import FreeDays from './FreeDays';
import Holidays from './Holidays';
import t from "../../../languages/pl";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreator from './../../../store/actions/index';
import SaveButton from "../Shared/SaveButton";

const SchedulesSettings = props => {
    const { height, daysOff, regularHolidays, movingHolidays, workingHours, allCars } = props;
    const [state, setState] = useState(workingHours);
    const [saveVisible, setSaveVisible] = useState(false);

    useEffect(() => {
        if(workingHours === state)
            setSaveVisible(false);
    }, [workingHours]);

    const handleDeleteRegularHoliday = (id) => {
        props.deleteRegularHoliday(id);
    };

    const handleDeleteMovingHoliday = (id) => {
        props.deleteMovingHoliday(id);
    };

    const handleDeleteDayOff = (id) => {
        props.deleteDayOff(id);
    };

    return (
        <Grid container>
            <Grid item xs={12} md={6}>
                <WorkingsDays
                    containerHeight={(height - 16)/2}
                    data={workingHours}
                    onChange={(data) => setState(data)}
                    onContentChanged={(value) => setSaveVisible(value)}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <FreeDays
                    tableHeight={(height - 16)/2}
                    freeDays={daysOff}
                    onHolidayAdd={data => props.putDaysOff(data)}
                    onDelete={(id) => handleDeleteDayOff(id)}
                    allCars={allCars}
                    onDataFromFile={(data) => props.importDaysOffFromFile(data)}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <Holidays
                    tableHeight={(height - 16)/2}
                    title={t.immovableFiests}
                    holidays={regularHolidays}
                    onHolidayAdd={(data) => props.putRegularHolidays(data)}
                    onDelete={(id) => handleDeleteRegularHoliday(id)}
                    deleteText={t.deleteRegularHolidayConfirmation}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <Holidays
                    tableHeight={(height - 16)/2}
                    title={t.movingHolidays}
                    holidays={movingHolidays}
                    onHolidayAdd={(data) => props.putMovingHolidays(data)}
                    onDelete={(id) => handleDeleteMovingHoliday(id)}
                    deleteText={t.deleteMovingHolidayConfirmation}
                />
            </Grid>
            <SaveButton
                visible={saveVisible}
                onClick={() => props.putSettingsWorkingHours(state)}
            />
        </Grid>
    );
};

const mapStateToProps = (state) => ({
   regularHolidays: state.settingsReducer.regularHolidays,
   movingHolidays: state.settingsReducer.movingHolidays,
   daysOff: state.settingsReducer.daysOff,
   workingHours: state.settingsReducer.workingHours,
   allCars: state.carsReducer.cars,
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

SchedulesSettings.propTypes = {
    height: PropTypes.number,
    //redux
    regularHolidays: PropTypes.array,
    movingHolidays: PropTypes.array,
    daysOff: PropTypes.array,
    workingHours: PropTypes.object,
    allCars: PropTypes.array,
    putDaysOff: PropTypes.func,
    putRegularHolidays: PropTypes.func,
    putMovingHolidays: PropTypes.func,
    deleteRegularHoliday: PropTypes.func,
    deleteMovingHoliday: PropTypes.func,
    deleteDayOff: PropTypes.func,
    importDaysOffFromFile: PropTypes.func,
    putSettingsWorkingHours: PropTypes.func
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SchedulesSettings);
